// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.util.enums.RentalGrowthRentEstimateSource

export enum RentalGrowthRentEstimateSource {
  LISTING_STATS = 'LISTING_STATS',
  ZILLOW_PSL = 'ZILLOW_PSL',
}

export const RentalGrowthRentEstimateSource_values = [
  RentalGrowthRentEstimateSource.LISTING_STATS,
  RentalGrowthRentEstimateSource.ZILLOW_PSL,
] as const;
